export class CareerTypeModel {
    constructor(public code: string, public name: string){}
}